const CURRENCY_SIGNALS: ICurrencySignals = {
  USD: "$",
  GBP: "£",
  CAD: "CA$",
  AUD: "AU$",
  NZD: "NZ$",
  ZAR: "R",
};

interface ICurrencySignals {
  USD: string;
  GBP: string;
  CAD: string;
  AUD: string;
  NZD: string;
  ZAR: string;
}

export default function getCurrencySignal(code: string) {
  return CURRENCY_SIGNALS[code as keyof ICurrencySignals] || "";
}
